<ng-lottie [options]="options"
           [width]="width"
           [height]="height"
           [styles]="styles"
           [containerClass]="containerClass"></ng-lottie>
